import type { Form } from '@adornis/forms/form.js';
import { html, nothing } from 'lit';
import type { AbstractSchoolType } from '../../../groups/api/getAbstractSchoolType.js';
import type { RegisterStudentData } from '../api/registerStudentWithSuSForm.js';
import { RegistrationField, yesNo } from './fields/registration-field.js';

const languages = [
  'Albanisch',
  'Arabisch',
  'Bosnisch',
  'Griechisch',
  'Italienisch',
  'Kroatisch',
  'Kurdisch (Kurmanci)',
  'Persisch (Farsi/ Dari)',
  'Polnisch',
  'Portugiesisch',
  'Russisch',
  'Serbisch',
  'Spanisch',
  'Türkisch',
  'Ukrainisch',
];
export const SgSusEntryFormSchoolingInterests = (props: {
  form: Form<RegisterStudentData>;
  abstractSchoolType: AbstractSchoolType;
}) =>
  html` <section class="card w-full">
    <div class="card-body gap-5 p-4 sm:p-6">
      <h2 class="font-semibold md:text-lg">Interesse an Zusatzangeboten</h2>
      <p>Ihre Angaben sind unverbindlich und noch keine Anmeldung zu diesen Angeboten.</p>
      <div class="grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-2">
        ${RegistrationField(props.form, ['interestInNativeLanguageCourses'], { label: 'Herkunftssprachlicher Unterricht', options: ['kein Interesse', ...languages] })}
        ${parseInt(props.form.document?.klassenstufe ?? '0') <= 6 ? RegistrationField(props.form, ['interestInWholeDaySchooling'], { label: 'Interesse an Nachmittagsbetreuung', options: yesNo }) : nothing}
      </div>
    </div>
  </section>`;
